import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { TankIcon } from 'app/agriculture/icons';
import { TasksForEntity } from 'app/agriculture/infobox/tasks/TasksForEntity/TasksForEntity';
import { NotesForEntity } from 'app/agriculture/infobox/notes/NotesForEntity';
import { useTank } from 'app/agriculture/queries/tanks/useTank';
import { TankLevelComponent } from 'app/agriculture/infobox/common/TankLevelComponent';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { InfrastructureActions } from 'app/agriculture/infobox/InfrastructureActions';
import { ShowOnMapButton } from 'app/agriculture/components/ContentBox/components/ShowOnMapButton';
import { SkeletonLineChart } from 'app/agriculture/charts/SkeletonLineChart/SkeletonLineChart';
import { TankLevelSkeleton } from 'app/agriculture/infobox/common/TankLevelSkeleton';
import { NotesForEntitySkeleton } from 'app/agriculture/infobox/notes/NotesForEntitySkeleton';
import { TasksForEntitySkeleton } from 'app/agriculture/infobox/tasks/TasksForEntity/TasksForEntitySkeleton';
import { TankLevelChartComponent } from 'app/agriculture/routes/Tanks/TankDetails/components/TankLevelChart/TankLevelChartComponent';

interface TankDetailsProps {
    tankId: string;
}

export function TankDetailsComponent({ tankId }: TankDetailsProps) {
    const { name, geometry } = useTank(tankId);

    return (
        <ContentBox
            title={name}
            className="TankDetailsComponent"
            Icon={TankIcon}
            variant="lg"
            showOnMapButton={<ShowOnMapButton position={geometry.coordinates} />}
        >
            <ContentBox.Section scrollable>
                <SuspenseWrapper loadingComponent={<TankLevelSkeleton />}>
                    <TankLevelComponent infrastructureId={tankId} />
                </SuspenseWrapper>
                <ContentBox.Section>
                    <SimpleGrid columns={3}>
                        <SuspenseWrapper loadingComponent={<TasksForEntitySkeleton />}>
                            <TasksForEntity assetId={tankId} />
                        </SuspenseWrapper>
                    </SimpleGrid>
                </ContentBox.Section>

                <SuspenseWrapper loadingComponent={<SkeletonLineChart title={'Avg Level'} />}>
                    <TankLevelChartComponent tankId={tankId} />
                </SuspenseWrapper>

                <SuspenseWrapper loadingComponent={<NotesForEntitySkeleton />}>
                    <NotesForEntity entityId={tankId} />
                </SuspenseWrapper>
                <InfrastructureActions sticky id={tankId} type="Tank" />
            </ContentBox.Section>
        </ContentBox>
    );
}
